import React, { useRef } from 'react'
import Navbar from './Navbar'
import { getUserDetails, setSensorLog, setSensorOnTime, getDeviceMachines } from "../Utility/AsyncStorageData";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import 'react-loading-skeleton/dist/skeleton.css'
import Header from "./Header";
import MachineCardGrid from './MachineCardGrid';

var runtimeid = 0
var statueBarInterval = 19;
var intervalId = 0;

function DeviceMachines() {


    const gb_machine_id = React.useRef("");
    const updateAnimation = useRef(false);

    let navigate = useNavigate();
    var userDetails = getUserDetails();
    var deviceWiseMachine = getDeviceMachines();

    const [error, setError] = React.useState('');
    const [graph, setGraph] = React.useState([]);
    const [runningListLog, setRunningListLog] = React.useState({});
    const [runningStatus, setRunningStatus] = React.useState({});
    const [colorWidthData, setColorWidthData] = React.useState([]);
    const [test, setTest] = React.useState(1);
    const [isLoading, setIsLoading] = React.useState(true);



    const errortimer = () => {
        setError(undefined)
    }

    const handleFetchMachineList = async () => {
        try {
            // console.log("*********** handleFetchMachineList ***********")


            let url = process.env.REACT_APP_BASE_URL + '/sensor/getSensorList';
            let body = {
                device_id: deviceWiseMachine.device_id
            }
            // console.log("===============getCompanyWiseSensorList======================", body)

            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        // console.log("getCompanyWiseSensorList======================", response.data.result)

                        const machineIds = response.data.result.map(item => item._id);
                        const machineIdsString = machineIds.map(item => `${item}`).join(', ');

                        // console.log("machineIds===================", machineIdsString);

                        const elements = machineIdsString.split(', ');
                        gb_machine_id.current = elements.map(element => `'${element}'`).join(', ');

                        //subscribeFCMTopic()

                        // console.log("response.data.resultresponse.data.resultresponse.data.result", response.data.result);

                        setGraph(response.data.result)
                        // console.log(response.data.result)

                        let temp = {};
                        let speed_temp = {};

                        Runtime()

                    }

                    else {

                        setError(response.data.msg)
                        setTimeout(() => errortimer(), 2000)
                        console.log("error in getCompanyWiseSensorList: ", response.data.msg);
                    }

                    // setLoading(false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }
            }).catch(error => {
                console.log("Error", error.response.status)
                if (error.response.status == 403) {
                    navigate("/");
                }
                setError("ERROR")
                setTimeout(() => errortimer(), 2000)
                // setLoading(false);
                return
            })
        } catch (error) {
            console.log("error ", error)
            //   setLoading(false);
            throw error;
        }

    }


    const Runtime = async () => {
        try {
            // console.log('*********** getMachineStatus api ***********');

            if (gb_machine_id.current.length != 0) {


                let url = process.env.REACT_APP_BASE_URL + '/sensor/getMachineStatus';
                let body = {
                    doa: moment().format('YYYY-MM-DD'),
                    machine_id: gb_machine_id.current
                };

                // console.log('*********** api hit ***********', body);

                // body.machine_id = elements.map(element => `'${element}'`).join(', ');
                // console.log(" getMachineStatus body", body)
                await axios
                    .post(url, body, {
                        headers: {
                            authorization: `${userDetails.access_token}`,
                        },
                    })
                    .then(response => {
                        if (response.status === 200) {
                            if (response.data.statusCode === 0) {
                                // console.log("running", response.data    )
                                setRunningListLog(response.data)
                                setRunningStatus(response.data.list)
                                setIsLoading(false)
                                statueBarInterval = statueBarInterval + 1;
                                if (statueBarInterval >= 20) {

                                    // console.log("statueBarInterval", statueBarInterval)
                                    statueBarInterval = 0;
                                    dashProgressBar()
                                }

                                updateAnimation.current = false

                            }
                            else if (response.data.statusCode === 2) {

                                setIsLoading(false)
                                console.log("getMachineStatus api error", response.data.msg)
                            }
                            else {

                                console.log("getMachineStatus api error", response.data.msg)
                                setError("ERROR")
                                setTimeout(() => errortimer(), 2000);
                            }
                        }
                    })
                    .catch(error => {
                        // console.log("Error", error.response.status)
                        // if (error.response.status == 403) {
                        //     navigate("/");
                        // }
                        setError('ERROR');
                        setTimeout(() => errortimer(), 2000);
                    });
                // setLoading(false);
            }
            runtimeid = setTimeout(() => Runtime(), 30000)
        } catch (error) {
            console.log('error ', error);
            runtimeid = setTimeout(() => Runtime(), 30000)
            throw error;
        }
        // setLoading(false);
        setIsLoading(false)
    }


    const dashProgressBar = async () => {
        try {
            // console.log('*********** dashProgressBar api ***********');

            if (gb_machine_id.current.length != 0) {

                let url = process.env.REACT_APP_BASE_URL + '/shift/fetchLogWiseData';
                let a = ""
                for (let key of gb_machine_id.current) {
                    a = a + key.replace("'", "")
                }

                let body = {
                    machine_ids: a
                };

                // console.log(" dashProgressBar body", body)
                await axios
                    .post(url, body, {
                        headers: {
                            authorization: `${userDetails.access_token}`,
                        },
                    })
                    .then(response => {
                        if (response.status === 200) {
                            if (response.data.statusCode === 0) {
                                // setMachineData(response.data.list)
                                // setMachineStates(response.data)
                                setColorWidthData(response.data.result)
                                // console.log(response.data.result)
                            } else {

                                console.log("dashProgressBar api error", response.data.msg)
                                setError(response.data.msg)
                                setTimeout(() => errortimer(), 2000);
                            }
                        }
                        else if (response.status == 403) {
                            // console.log("refreshAccessToken: ");
                            // refreshAccessToken();
                            dashProgressBar();
                        }
                    })
                    .catch(error => {
                        if (error.response.status == 403) {
                            navigate("/");
                        }
                        console.log("ERROR", error)
                        setError('ERROR');
                        setTimeout(() => errortimer(), 2000);
                    });
                // setLoading(false);
            }

        } catch (error) {
            console.log('error ', error);
            setError('ERROR');
            setTimeout(() => errortimer(), 2000);
            // statueBarInterval = setTimeout(() => dashProgressBar(), 30000)
            throw error;
        }
    }

    const machineTime = (mech_id, data) => {
        if (runningStatus[mech_id]) {
            // console.log("machineTime" , runningStatus[mech_id].machine_current_status, data)
            if (runningStatus[mech_id].machine_current_status == "D") {
                return ("#E9E9E9") //gray
            }
            else {
                if (runningStatus[mech_id].efficiency >= data.Y) {
                    return "#F1F9EE" //green
                }
                else if (runningStatus[mech_id].efficiency >= data.R) {
                    return "#FEFBED" // orange
                }
                else {
                    return "#FBF3F3" // red
                }
            }
        }
        else {
            return ("#D3D3D3") //gray
        }
    }


    const machineStatus = (mech_id) => {
        if (Object.keys(runningStatus).length && runningStatus[mech_id]) {
            let color = 'gray';

            if (runningStatus[mech_id].machine_current_status === "D") {
                color = 'blue';
            } else if (runningStatus[mech_id].machine_current_state === "0") {
                color = 'red';
            } else if (runningStatus[mech_id].machine_current_state === "1") {
                color = 'orange';
            } else {
                color = 'green';
            }

            return (
                <div
                    className="clock"
                    style={{
                        // position: "absolute",
                        // top: "-2px",
                        // right: "-2px",
                        backgroundColor: color,
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                    }}
                ></div>
            );
        }
    };


    const updateOnTimeInSec = () => {
        if (Object.keys(runningStatus).length) {
            setRunningStatus((prevData) => {
                const updatedData = { ...prevData }; // Create a shallow copy of the previous state
                for (let key of graph) {
                    // console.log("key.sensor_data", updatedData, key.machine_id)
                    if (updatedData[key._id].machine_current_state === '2') {
                        const timeObject = new Date(
                            `2000-01-01T${updatedData[key._id].on_time}`
                        );
                        timeObject.setSeconds(timeObject.getSeconds() + 1);
                        const newTimeString = timeObject.toLocaleTimeString('en-US', {
                            hour12: false,
                        });

                        // Create a new object for the specific item and update the on_time property
                        updatedData[key._id] = {
                            ...updatedData[key._id],
                            on_time: newTimeString,
                        };
                    }
                }
                return updatedData;
            });
        }

    }

    const borderRadius = (serialNo, machineId) => {
        // console.log(serialNo, machineId ,colorWidthData[machineId].length )
        if (colorWidthData[machineId].length == 1) {
            return "10px"
        }
        else if (serialNo == colorWidthData[machineId].length - 1) {
            // console.log(colorWidthData[machineId])
            return " 0 10px 10px 0 "
        }
        else if (serialNo == 0) {
            return " 10px 0 0 10px"
        }
    }


    const showShift = (machine_id) => {
        const time = moment(runningStatus[machine_id].start_time, 'HH:mm:ss')
        const start = time.format('HH:mm');


        const time1 = moment(runningStatus[machine_id].end_time, 'HH:mm:ss')
        const end = time1.format('HH:mm');

        return (start + " - " + end)

    }

    const PrevshowShift = (machine_id) => {
        const time = moment(runningStatus[machine_id].previousData.shift_start_time)
        const start = time.format('HH:mm');


        const time1 = moment(runningStatus[machine_id].previousData.shift_end_time)
        const end = time1.format('HH:mm');

        // console.log("start time - end time", start,end, time, time1)
        return (start + " - " + end)

    }

    const NavigateToLogs = (item) => {
        setSensorLog(JSON.stringify(item))

        let temp = {
            on_time: runningStatus[item._id].on_time ?? 0,
            efficiency: runningStatus[item._id].efficiency ?? 0,
            mcs: runningStatus[item._id].machine_current_state ?? 0
        }

        setSensorOnTime(JSON.stringify(temp))
        navigate("/machineLogs");

    }

    const ButtonColor = (mech_id, data) => {
        if (runningStatus[mech_id]) {
            if (runningStatus[mech_id].machine_current_status == "D") {
                return ("#1E2A7A") //gray
            }
            else {
                if (runningStatus[mech_id].efficiency >= data.Y) {
                    return ("#8FCD71") //green
                }
                else if (runningStatus[mech_id].efficiency >= data.R) {
                    return ("#F6E069") // orange
                }
                else {
                    return ("#F97171") // red
                }
            }
        }
        else {
            return ("#D3D3D3") //gray
        }
    }

    clearInterval(intervalId);
    intervalId = setInterval(() => {
        updateOnTimeInSec();
    }, 1000);

    const navbarRender = (data) => {
        // console.log('Data received from child:', data);
        setTest(!test)
    };

    React.useEffect(() => {
        handleFetchMachineList()
    }, []);
    return (
        <div className='main'>

            <div>
                <Navbar />
            </div>

            <div className='Admin_menu'>
                <Header show={1} sendNavbarToParent={navbarRender} />


                <div className='machines'>

                    <MachineCardGrid
                        graph={graph}
                        runningStatus={runningStatus}
                        colorWidthData={colorWidthData}
                        NavigateToLogs={NavigateToLogs}
                        machineTime={machineTime}
                        machineStatus={machineStatus}
                        showShift={showShift}
                        PrevshowShift={PrevshowShift}
                        ButtonColor={ButtonColor}
                        machineKey="_id"
                        updateAnimation={updateAnimation.current}
                        isLoading={isLoading}
                    />

                    {updateAnimation.current = true}
                </div>



            </div>
            <div>
                <p className='error'>{error}</p>
            </div>


        </div >
    )
}

export default DeviceMachines